import React from "react";
import Registration from "@tvg/rma";
import tvgConf from "@tvg/conf";
import isRn, { isRnTablet } from "../../utils/isRn";

const MicroApp = () => {
  const RnDevice = isRnTablet ? "tablet" : "mobile";

  return <Registration device={isRn ? RnDevice : tvgConf().device} />;
};

export default MicroApp;
